export default __webpack_public_path__ + "static/media/finale.6c6506be.png";